import type { TransferOptionsIssue } from 'features/feeBasedInstantTransfer/hooks/useTransferOptions';

export type TransferBlockingError =
  | { kind: 'retry'; target: 'source' | 'destination' | 'limits' }
  | { kind: 'blocked'; message?: string };

interface TransferLoadIssues {
  sourceIssue: TransferOptionsIssue | undefined;
  destinationIssue: TransferOptionsIssue | undefined;
  hasLimitsError: boolean;
}

function toBlockingError(
  issue: TransferOptionsIssue,
  target: 'source' | 'destination',
): TransferBlockingError {
  return issue.kind === 'requestFailed'
    ? { kind: 'retry', target }
    : { kind: 'blocked', message: issue.message };
}

/**
 * Source issues outrank destination issues because destinations depend on the
 * selected source; both outrank limits because limits depend on the route.
 */
export function getTransferBlockingError({
  sourceIssue,
  destinationIssue,
  hasLimitsError,
}: TransferLoadIssues): TransferBlockingError | undefined {
  if (sourceIssue) {
    return toBlockingError(sourceIssue, 'source');
  }
  if (destinationIssue) {
    return toBlockingError(destinationIssue, 'destination');
  }
  if (hasLimitsError) {
    return { kind: 'retry', target: 'limits' };
  }
  return undefined;
}
